import React, { FC } from "react";
import { TreeItem } from "@mui/x-tree-view";
import FireplaceRoundedIcon from "@mui/icons-material/FireplaceRounded";
import { Fireplace } from "./Fireplace";
import { useTranslation } from "react-i18next";

export interface FireplaceTreeItemProps {
  fireplace: Fireplace;
}

export const FireplaceTreeItem: FC<FireplaceTreeItemProps> = (props) => {
  const { fireplace } = props;
  const { t } = useTranslation("my-chimney-ts-translations");

  let label = t("Fireplace");
  if (fireplace.mcFields?.name != null) {
    label += `: ${fireplace.mcFields?.name}`;
  }

  return (
    <TreeItem
      itemId={`Fireplace:${fireplace.id}`}
      label={label}
      slots={{
        expandIcon: FireplaceRoundedIcon,
        collapseIcon: FireplaceRoundedIcon,
        endIcon: FireplaceRoundedIcon,
      }}
    />
  );
};
